import Modal from "../shared/Modal";
import "./ModalConsent.css";

type ModalConsentProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalConsent = ({ isOpen, onClose, onContinue }: ModalConsentProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-consent">
          <div className="modal-collection-consent-title">Please Note</div>

          <div className="modal-collection-consent-content">
            <p>
              By continuing, you agree to the{" "}
              <a
                href="https://usewinslow.com/termsofservice"
                target="_blank"
                rel="noreferrer">
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://usewinslow.com/privacypolicy"
                target="_blank"
                rel="noreferrer">
                Privacy Policy
              </a>
              .
            </p>
          </div>

          <div className="modal-collection-consent-footer">
            <div className="modal-collection-consent-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Continue
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalConsent;
